import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: { base: "!text-base" },
  variants: {
    color: {
      white: "text-white",
      primary: "text-primary",
      secondary: "text-secondary",
      inactive: "text-gray-dark",
    },
  },
  defaultVariants: {
    color: "secondary",
  },
});

interface IProps {
  color?: VariantProps<typeof styles>["color"];
  children: ReactNode;
  className?: string;
  testId?: string;
}
const P = ({ color, className, children }: IProps) => {
  const { base } = styles({ color, className });

  return <p className={base({ className })}>{children}</p>;
};
export default P;
